import type { CSSProperties } from 'react';
import { wedgeExactRole } from './wedgeRoles.js';

export type WedgeResearchBarLook = 'research-bar-chip' | 'research-bar-expand';
export const isWedgeResearchBarLook = (look: string | undefined): look is WedgeResearchBarLook => look === 'research-bar-chip' || look === 'research-bar-expand';

// The caller sets the placement, the accent fill and border, and the shadow of the folded chip, and the ink of the expand toggle.
export function wedgeResearchBarStyle(look: WedgeResearchBarLook): CSSProperties {
  if (look === 'research-bar-chip') return {
    position: 'absolute', zIndex: 35, height: 40, borderRadius: 999,
    backdropFilter: 'saturate(180%) blur(20px)', WebkitBackdropFilter: 'saturate(180%) blur(20px)',
    display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', fontFamily: wedgeExactRole('font'),
    animation: `prepFadeUp 240ms ${wedgeExactRole('ease')}`, WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
  };
  return {
    background: 'none', border: 0, padding: '10px 10px', cursor: 'pointer', minHeight: 36, minWidth: 44,
    fontSize: 11, fontWeight: 700, letterSpacing: 0.3,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3,
  };
}
